import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 40px 0px 20px 0px;
`

export const CompletedUsersCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 24px 16px 16px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(31, 52, 77, 0.08);
`

export const DashboardContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 40px 0px;

  @media (max-width: 900px) {
    flex-wrap: wrap;

    > * {
      width: 100% !important;
      max-width: 720px;
      margin: 0 !important;
    }
  }
`


interface IRow {
  width?: string
  height?: string
  margin?: string
  padding?: string
  justifyContent?: string
  alignItems?: string
}

export const Row = styled.div<IRow>`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || 'auto'};
  margin: ${({ margin }) => margin || '0px'};
  padding: ${({ padding }) => padding || '0px'};
  display: flex;
  flex-direction: row;
  justify-content: ${({ justifyContent }) => justifyContent || 'space-between'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};

  @media (max-width: 1200px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`

export const CompletedUsersHeader = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 520px) minmax(0, 1fr);
  align-items: center;
  gap: 24px;
  margin: 0 0 24px;

  h4 {
    margin: 0;
    justify-self: start;
    white-space: nowrap;
  }

  > *:nth-child(2) {
    position: absolute;
    left: 50%;
    width: min(520px, 40%);
    transform: translateX(-50%);
  }

  > ${Row} {
    justify-self: end;
    width: auto;
    white-space: nowrap;
  }

  > *:last-child {
    position: absolute;
    right: 0;
    width: auto;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 12px;

    h4,
         > *:nth-child(2),
    > ${Row} {
           position: static;
      justify-self: stretch;
           width: 100%;
           transform: none;
    }

         > *:last-child {
           position: static;
           width: 100%;
         }
  }
`

export const ParticipantTable = styled.div`
  .process-detail-table {
    col:nth-child(1) { width: 4% !important; }
    col:nth-child(2) { width: 12% !important; }
    col:nth-child(3) { width: 22% !important; }
    col:nth-child(4) { width: 16% !important; }
    col:nth-child(5) { width: 16% !important; }
    col:nth-child(6) { width: 18% !important; }
    col:nth-child(7) { width: 12% !important; }
    th { white-space: normal; line-height: 1.4; }
    td { white-space: normal; overflow-wrap: break-word; }
    td[data-label='Follow Up'], td[data-label='Última medición completada'] { font-size: 13px; }
  }
`

export const VerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  background-color: #C2C2C2;
`

interface IProps {
  width?: string;
  height?: string;
  maxHeigth?: string;
  padding?: string;
  margin?: string;
  justifyContent?: string;
  alignItems?: string;
  float?: string
  alignSelf?: string;
  maxWidth?: string;
  backgroundColor?: string;
  shadow?: string;
  flexDirection?: string;
}

export const BlueContainer = styled.div<IProps>`
    overflow: hidden;
    display: flex;
    align-self: ${props => props.alignSelf ? props.alignSelf : 'center'};
    width: ${props => props.width ? props.width : '100%'};
    max-width: ${props => props.maxWidth ? props.maxWidth : '100%'};
    height: ${props => props.height ? props.height : '100%'};
    max-height: ${props => props.maxHeigth ? props.maxHeigth : '100%'};
    margin: ${props => props.margin ? props.margin : '0'};
    padding: ${props => props.padding ? props.padding : '10px'};
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'flex-start'};
    align-items: ${props => props.alignItems ? props.alignItems : 'flex-start'};
    float: ${props => props.float ? props.float : 'none'};
    flex-direction: ${props => props.flexDirection ? props.flexDirection : 'column'};
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(45, 116, 156)'};
    box-shadow: ${props => props.shadow ? props.shadow : '0px 2px 10px rgba(0, 0, 0, 0.1)'};
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover {
      transform: scale(1.02);
    }
`;
